import { KnowledgeValue, RateSelectorValue, Trait, UsefulInfo } from "../types/common";
import { FAMILY_NIGHT_SLEEP_SLECTOR_DATA, FAMILY_OTHER_PEOPLE_PRESENCE_SLECTOR_DATA, FAMILY_SMOKE_ACCEPTANCE_SLECTOR_DATA, FAMILY_WEEKEND_NEEDS_SLECTOR_DATA } from "./family";

export const DEFAULT_COMMON_USEFUL_INFO: UsefulInfo[] = [
  { name: 'Di notte dorme?', value: FAMILY_NIGHT_SLEEP_SLECTOR_DATA[0].value},
  { name: 'Bisogno nei weekend', value: FAMILY_WEEKEND_NEEDS_SLECTOR_DATA[0].value},
  { name: "C'è la stanza per la badante", value: "No"},
  { name: 'Presenza di telecamere di sorveglianza', value: "No"},
  { name: 'Presenza di altri familiari in casa', value: FAMILY_OTHER_PEOPLE_PRESENCE_SLECTOR_DATA[0].value},
  { name: 'Accettereste una persona fumatrice', value: FAMILY_SMOKE_ACCEPTANCE_SLECTOR_DATA[0].value},
];

export const NATIONALITIES_SELECT: {key: number | string; value: string}[] = [
  { key: 'Europa', value: 'Europa' },
  { key: 'Asia', value: 'Asia' },
  { key: 'Africa ', value: 'Africa'},
]

export const ALTER_TRAIT = 'Lucida' as const;
export const AUTONOMOUS_WALKING_TRAIT = 'Deambula in autonomia' as const;
export const PARKINSON_TRAIT = 'Parkinson' as const;
export const ALZHEIMER_TRAIT = 'Alzheimer' as const;
export const DEMENTIA_TRAIT = 'Demenza senile' as const;
export const INCONTINENCE_PAD_TRAIT = 'Cambio pannolone' as const;
export const BED_HYGIENE_TRAIT = 'Igiene a letto' as const;
export const STRUGGLE_TO_WALK_TRAIT = 'Demabula a fatica' as const;
export const BREATHING_PROBLEMS_TRAIT = 'Respira a fatica' as const;
export const OXYGEN_THERAPY_TRAIT = 'Ossigeno terapia' as const;
export const CATHETER_TRAIT = 'Catetere' as const;
export const STROKE_TRAIT = 'Ictus' as const;
export const DIABETE_TRAIT = 'Diabete' as const;
export const INSULINE_TRAIT = 'Insulino dipendente' as const;
export const SOLLEVATORE_TRAIT = 'Uso sollevatore' as const;
export const ANIMAL_PRESENCE_TRAIT = 'Presenza animali in casa' as const;
export const TRAITS = [
  ALTER_TRAIT,
  AUTONOMOUS_WALKING_TRAIT,
  PARKINSON_TRAIT,
  ALZHEIMER_TRAIT,
  DEMENTIA_TRAIT,
  INCONTINENCE_PAD_TRAIT,
  BED_HYGIENE_TRAIT,
  STRUGGLE_TO_WALK_TRAIT,
  BREATHING_PROBLEMS_TRAIT,
  OXYGEN_THERAPY_TRAIT,
  CATHETER_TRAIT,
  STROKE_TRAIT,
  DIABETE_TRAIT,
  INSULINE_TRAIT,
  SOLLEVATORE_TRAIT,
  ANIMAL_PRESENCE_TRAIT,
] as const;

export const TRAITS_SELECTOR_DATA: {
  key: Trait; 
  value: Trait
}[] = [
  { key: 'Lucida', value: 'Lucida' },
  { key: 'Deambula in autonomia', value: 'Deambula in autonomia' },
  { key: 'Parkinson', value: 'Parkinson' },
  { key: 'Alzheimer', value: 'Alzheimer' },
  { key: 'Demenza senile', value: 'Demenza senile' },
  { key: 'Cambio pannolone', value: 'Cambio pannolone' },
  { key: 'Igiene a letto', value: 'Igiene a letto' },
  { key: 'Demabula a fatica', value: 'Demabula a fatica' },
  { key: 'Respira a fatica', value: 'Respira a fatica' },
  { key: 'Ossigeno terapia', value: 'Ossigeno terapia' },
  { key: 'Catetere', value: 'Catetere' },
  { key: 'Ictus', value: 'Ictus' },
  { key: 'Diabete', value: 'Diabete' },
  { key: 'Insulino dipendente', value: 'Insulino dipendente' },
  { key: 'Uso sollevatore', value: 'Uso sollevatore' },
  { key: 'Presenza animali in casa', value: 'Presenza animali in casa' },
]

export const KNOWEDGE_SELECTOR_DATA: {
  key: KnowledgeValue;
  value: KnowledgeValue
}[] = [
  { key: '1', value: '1' },
  { key: '1.5', value: '1.5' },
  { key: '2', value: '2' },
  { key: '2.5', value: '2.5' },
  { key: '3', value: '3' },
  { key: '3.5', value: '3.5' },
  { key: '4', value: '4' },
  { key: '4.5', value: '4.5' },
  { key: '5', value: '5' },
  { key: '5.5', value: '5.5' },
  { key: '6', value: '6' },
  { key: '6.5', value: '6.5' },
  { key: '7', value: '7' },
  { key: '7.5', value: '7.5' },
  { key: '8', value: '8' },
  { key: '8.5', value: '8.5' },
  { key: '9', value: '9' },
  { key: '9.5', value: '9.5' },
  { key: '10', value: '10' },
]

export const RATE_SELECTOR_VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;
// export const RATE_SELECTOR_VALUES = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10] as const;